<sd-input-search-modal
  [isLoading]="isLoading$ | async"
  [placeholder]="placeholder"
  [inputControl]="inputControl"
  (clear)="clear()"
  (enterSearchInput)="onEnterSearchInput()"
></sd-input-search-modal>
